import i from './trucking-history.container';

export default i;
